// @flow
import React from 'react'
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import {styles} from './Styles/TextSection.Style'

type Props = {
  classes: { [string]: string }
}

class TextSection extends React.Component {
  props: Props

    render () {
      const {classes} = this.props

      return (
        <div className={classNames(classes.conatainer, 'container wrap')}>
          <div className='row'>
            <div className={classNames(classes.highlightTitle, classes.padding, 'col-sm-6 col-xs-12')}>
              <div className={classes.line} />
              The ultimate SKU generator. Set it up to your standard once, save
              the time from that point on.
            </div>
            <div className={classNames(classes.paragraph, classes.padding, 'col-sm-6 col-xs-12')}>
              <p>
                With Partsee creating your SKUs to your standards is just a
                matter of seconds. The system learns your conventions and
                generates all SKUs for your new products automatically. No more
                Excel spreadsheets that take hours to create and even longer to
                maintain.
              </p>
              <p>
                From the start of your collection all the way to the management
                of your production, Partsee is here with you. It keeps tracks of
                your prices, your documents and notes and it keeps your entire
                team on the same page.
              </p>
            </div>
          </div>
        </div>
      )
    }
}

export default injectSheet(styles)(TextSection)



// WEBPACK FOOTER //
// ./src/layouts/TextSection.jsx